import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.00129 20C4.29703 20 3.82603 19.2979 4.06107 18.6586L4.10686 18.5528L5.26228 16.242C5.69968 15.3672 5.94836 14.4115 5.99372 13.4369L6.00129 13.1115V10C6.00129 7.02694 8.16367 4.55893 11.0015 4.08293L11.0013 3C11.0013 2.44772 11.449 2 12.0013 2C12.5536 2 13.0013 2.44772 13.0013 3L13.0021 4.08309C15.7606 4.54627 17.8807 6.89172 17.9963 9.75347L18.0013 10V13.1115C18.0013 14.0895 18.2062 15.0555 18.6015 15.9474L18.7403 16.242L19.8957 18.5528C20.2107 19.1827 19.7933 19.918 19.1164 19.9936L19.0013 20H14.0013C14.0013 21.1046 13.1059 22 12.0013 22C10.8967 22 10.0013 21.1046 10.0013 20H5.00129Z",
		fill: "currentColor"
	})
});
export default SvgNotifications;
